import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "layout-footer footer" }
const _hoisted_2 = { class: "container-fluid d-flex flex-wrap justify-content-between text-center container-p-x py-2" }
const _hoisted_3 = { class: "d-sm-block d-none" }
const _hoisted_4 = { class: "d-xs-block d-sm-none d-md-none d-lg-none dxl-none text-center w-100" }
const _hoisted_5 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createTextVNode(" Copyright © " + _toDisplayString(_ctx.date) + " ", 1),
        _cache[1] || (_cache[1] = _createElementVNode("span", { class: "footer-text fw-bolder" }, "HealthCourse Inc.", -1))
      ]),
      _createElementVNode("div", _hoisted_4, [
        (_ctx.store.getters.partner && _ctx.store.getters.partner.is_sim && _ctx.store.getters.partner.slug != 'simclusive')
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("img", {
                src: "/img/partners/SIMclusive_Logo.png",
                alt: "Simclusive Logo",
                title: "Simclusive Logo",
                height: "45",
                onClick: _cache[0] || (_cache[0] = ($event: any) => {_ctx.router.push({name:'dashboard'});})
              })
            ]))
          : _createCommentVNode("", true),
        _createTextVNode(" Copyright © " + _toDisplayString(_ctx.date) + " ", 1),
        _cache[2] || (_cache[2] = _createElementVNode("span", { class: "footer-text fw-bolder" }, "HealthCourse Inc.", -1))
      ]),
      _cache[3] || (_cache[3] = _createStaticVNode("<div class=\"d-none d-md-block\"><a href=\"#/contactus\" class=\"footer-link ms-4\">Contact Us / Help</a><a href=\"#/terms-of-service\" class=\"footer-link ms-4\">Terms of Service</a><a href=\"#/privacy-policy\" class=\"footer-link ms-4\">Privacy Policy</a><a href=\"https://healthcourse.com/cookie-policy\" class=\"footer-link ms-4\" target=\"_blank\">Cookie Policy</a><button id=\"ot-sdk-btn\" class=\"ot-sdk-show-settings cookie-link btn btn-link\">Cookie Settings</button></div>", 1))
    ])
  ]))
}